<template>
  <div id="R0" class="sub">
    <div class="wrapper">
      <kg-header :headerType=0 />
      <div id="content">
        <div class="inner_static">
          <h1 class="tit1">メンバー登録完了</h1>
          <div class="vm_wrap">
            <div class="inner_static">
              <h2 class="ins_tit">メンバー登録が完了しました。</h2>
              <p class="ins_lead">
                〇〇に登録いただき、ありがとうございます。<br>
                ご登録いただいた内容をメールにてお送りしましたので、ご確認ください。
              </p>
            </div>
          </div>
          <div class="fixed_btn_area">
            <div class="inner_static">
              <a class="btn1" @click="btnTopClick()">TOPへ</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// kaggul Module
import Header from '../components/common/HomeIconHeader'

export default {
  components: {
    'kg-header': Header
  },
  methods: {
    btnTopClick: function () {
      this.$router.push('/kagull/login')
    }
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/RegistUserComplete.vue